jQuery(document).ready(function ($) {

    var module_name = 'cards';
    $('.module.' + module_name.replace(/_/g, '-') + '-module').each(function (index) {
        let arrows = $(this).find(".arrow");
        let prevArrow = arrows.filter('.arrow-prev');
        let nextArrow = arrows.filter('.arrow-next');
        let box = $(this).find(".hs__wrapper");
        let width = $(window).width();

        prevArrow.fadeOut();
        if (box.length > 0 && width >= 1200) {
            let x = 0;
            let mx = 0;
            let maxScrollWidth = box[0].scrollWidth - (box[0].clientWidth / 2) - (box.width() / 2);

            $(arrows).on('click', function () {
                if ($(this).hasClass("arrow-next")) {
                    $(this).fadeOut();
                    x = ((box.width() / 2)) + box.scrollLeft() + 8;
                    box.animate({
                        scrollLeft: x,
                    })
                } else {
                    $(this).fadeOut();
                    x = ((box.width() / 2)) - box.scrollLeft() + 8;
                    box.animate({
                        scrollLeft: -x,
                    })
                }

            });

            $(box).on({
                mousemove: function (e) {
                    var mx2 = e.pageX - this.offsetLeft;
                    if (mx) this.scrollLeft = this.sx + mx - mx2;
                },
                mousedown: function (e) {
                    this.sx = this.scrollLeft;
                    mx = e.pageX - this.offsetLeft;
                },
                scroll: function () {
                    toggleArrows();
                }
            });

            $(document).on("mouseup", function () {
                mx = 0;
            });

            function toggleArrows() {
                if (box.scrollLeft() > maxScrollWidth - 20) {
                    // disable next button when right end has reached
                    nextArrow.stop(true, true).fadeOut();
                } else if (box.scrollLeft() < 20) {
                    // disable prev button when left end has reached
                    prevArrow.stop(true, true).hide()
                } else {
                    // both are enabled
                    nextArrow.fadeIn();
                    prevArrow.fadeIn();
                }
            }
        }
        /* Casino Carousel */
        $dots_data = {
            "casino": {
                "container": ".casino__cards",
                "card": ".card"
            },
            "slot": {
                "container": ".slots__cards",
                "card": ".slots__cards__single"
            }
        };
        Object.keys($dots_data).forEach(element => {
            if (width <= 992) {
                let casino_container = $(this).find($dots_data[element]["container"]);
                let module_wrapper = $(this);
                $(this).find(".slide_0").css("background", "linear-gradient(180deg, #FFC801 0%, #FF9900 100%)");
                casino_container.on("scroll", function (e) {
                    let cards = $(this).find($dots_data[element]["card"]);
                    for (let i = 0; i < $(cards).length; i++) {
                        const result = isInViewport(cards[i]);
                        if (result) {
                            module_wrapper.find(".slide_" + i).css("background", "linear-gradient(180deg, #FFC801 0%, #FF9900 100%)").siblings().css("background", "");
                            break;
                        }
                    }
                });
            }
        });

        //Archive
        var end = modules_object["cards"][0]["casino_count"];
        var lim = modules_object["cards"][0]["cards_max"];
        var count = 0;
        if($('.casino__cards .card').length >= end){
            $('.load_more').hide();
        }

        //Load more
        $(this).find('.load_more a').click(function(e){
            e.preventDefault();
            count++;
    
            $.ajax({
                url: script_object.ajax_url,
                data:{action:'load_more', count: count, limit:lim},
                type:'POST',
                beforeSend: function() {
                    $('.load_more').hide();
                },
                success:function(result){
                    $('.casino__cards').append(result);
                    if($('.casino__cards .card').length < end){
                        $('.load_more').show();
                    }
                },
                error: function(result)
                {
                    //console.log("error:"+ result);
                }
            })
        })

        function isInViewport(element) {
            const rect = element.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    });
});

